export default function LoadingPage() {
    return (
        <div className="flex h-screen items-center justify-center">
            <div>
                <div className="loading loading-xl"></div>
            </div>
        </div>
    );
}